import { Component, Inject } from '@angular/core';
import { Participant } from '../../../interfaces/participant';
import { MAT_DIALOG_DATA, MatDialogContent, MatDialogRef, MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import { MatOptionModule } from '@angular/material/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-participant-delete-dialog',
  imports: [MatDialogModule, MatDialogContent, MatButtonModule, MatFormFieldModule, MatSelectModule, MatInputModule, MatOptionModule, CommonModule, FormsModule],
  templateUrl: './participant-delete-dialog.component.html',
  styleUrl: './participant-delete-dialog.component.scss'
})
export class ParticipantDeleteDialogComponent {
  constructor(
    private readonly ref: MatDialogRef<ParticipantDeleteDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { participant: Participant }
  ) {
    // Assign the incoming item to the local variable
    this.currentParticipant = data.participant;
  }
  
  currentParticipant!: Participant;
  selectedReason: string | undefined = undefined;
  otherReason: string | undefined = undefined;

  // Archiving reasons similar to pairs but tailored for individual participants
  readonly reasons = [
    'Transplanted within cross-over program',
    'Transplanted with postmortal kidney',
    'Transplanted with kidney of other living donor',
    'Transplanted with kidney of an altruist in domino chain',
    'Transplanted regardless of blood group incompatibility',
    'Transplanted regardless of HLA incompatibility',
    'Patient or donor deceased',
    'Medical problems patient',
    'Psychological problems patient',
    'Medical problems donor',
    'Psychological problems donor',
    'Patient declined participation',
    'Donor declined participation',
    'Other reason: '
  ];

  otherReasonSelected(): boolean {
    return this.selectedReason === 'Other reason: ';
  }

  isFormValid(): boolean {
    if (!this.selectedReason) return false;
    if (this.otherReasonSelected() && (!this.otherReason || this.otherReason.trim() === '')) {
      return false;
    }
    return true;
  }

  cancel(): void {
    this.ref.close(false);
  }

  removeParticipant(): void {
    if (!this.isFormValid()) return;
    
    const reason = this.otherReasonSelected() 
      ? (this.selectedReason || '') + (this.otherReason || '') 
      : this.selectedReason!;
    
    this.ref.close({ confirmed: true, reason });
  }
}
